'use client';

import { Close as CloseIcon } from '@mui/icons-material';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import classes from './InjuryNotificationDialog.module.scss';
import Button from '../Buttons/Button';
interface InjuryNotificationDialogProps {
  open: boolean;
  onClose: () => void;
  urgentCareCentersLink?: string;
}
const InjuryNotificationDialog = ({
  open,
  onClose,
  urgentCareCentersLink
}: InjuryNotificationDialogProps) => {
  const handleFindAnotherLocation = () => {
    window.open(urgentCareCentersLink || 'http://wellnow.com/urgent-care-centers', '_blank');
    onClose();
  };
  return <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth className={classes['injury-dialog']} aria-labelledby="injury-notification-title" aria-describedby="injury-notification-description" data-sentry-element="Dialog" data-sentry-component="InjuryNotificationDialog" data-sentry-source-file="InjuryNotificationDialog.tsx">
			<DialogTitle className={classes['dialog-title']} data-sentry-element="DialogTitle" data-sentry-source-file="InjuryNotificationDialog.tsx">
				<Typography component="h2" id="injury-notification-title" data-sentry-element="Typography" data-sentry-source-file="InjuryNotificationDialog.tsx">
					Injury Services Notice
				</Typography>
				<IconButton aria-label="Close injury notification" onClick={onClose} className={classes['close-button']} data-sentry-element="IconButton" data-sentry-source-file="InjuryNotificationDialog.tsx">
					<CloseIcon data-sentry-element="CloseIcon" data-sentry-source-file="InjuryNotificationDialog.tsx" />
				</IconButton>
			</DialogTitle>
			<DialogContent className={classes['dialog-content']} data-sentry-element="DialogContent" data-sentry-source-file="InjuryNotificationDialog.tsx">
				<Typography id="injury-notification-description" className={classes['alert-message']} data-sentry-element="Typography" data-sentry-source-file="InjuryNotificationDialog.tsx">
					Please note injury-related services needing an x-ray such as broken bones, strains, etc. are not
					available at this location. Locate the nearest WellNow center by visiting
					http://wellnow.com/urgent-care-centers.
				</Typography>
				<Box className={classes['button-container']} data-sentry-element="Box" data-sentry-source-file="InjuryNotificationDialog.tsx">
					<Button onClick={handleFindAnotherLocation} variant="primary" aria-label="Find another WellNow location" data-sentry-element="Button" data-sentry-source-file="InjuryNotificationDialog.tsx">
						Find Another Location
					</Button>
				</Box>
			</DialogContent>
		</Dialog>;
};
export default InjuryNotificationDialog;